import Vue from "vue"
const _vue = new Vue()
const get = async () => {
    try{
        const timestamp = await fetchDateTime()
        let d = new Date( timestamp *1000 )
        return {
            time: d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds(),
            hours: d.getHours(),
            min: d.getMinutes(),
            sec: d.getSeconds()
        }
    }catch {
        return {}
    }

}
const fetchDateTime = async () => {
    const URL = _vue.$API_URL + '/datetimeNow'
    const get = await _vue.$http.get( URL, {
        headers: {
                    Token: localStorage.getItem("access_token")
        }
    })
    return get.data
}
export default get